import type { InterestRateNameListParams, InterestRateNameListResponse, InterestRateParams, InterestRateResponse, SimpleQueryParams, SimpleQueryResponse } from './types'
import { useRequestApi4 } from '~/composables/useRequest'

// 查询利率详情 - api4
export function getInterestRate(params: InterestRateParams): InterestRateResponse {
  const url = `/third/calculator/interest-rate`
  return useRequestApi4().get(`${url}`, params)
}

// 查询利率名称列表 - api4
export function getInterestRateNameList(params: InterestRateNameListParams): InterestRateNameListResponse {
  const url = `/third/calculator/interest-rate-name-list`
  return useRequestApi4().get(`${url}`, params)
}
// 查询贷款计算器数据(简要) - api4
export function getSimpleQuery(params: SimpleQueryParams): SimpleQueryResponse {
  const url = `/third/calculator/simple-query`
  return useRequestApi4().get(`${url}`, params)
}

/**
 * 获取资讯数据
 * */
interface newsDataParams {
  cityId: number // 城市ID
  issueId: number // 楼盘ID
  media: string // 是否要封装房超视界信息，不需要传0，默认1
  page: number // 页码
  pageSize: number // 分页大小
}
export function getNewsData(params: newsDataParams) {
  const url = `/news/api/news/floor`
  return useRequestApi4().get(`${url}`, params)
}
